<template>
    <form class="selector">
        <div class="form-group form-group-toggle">
            <input
                :id="parameter"
                type="checkbox"
                class="form-control toggle"
                :name="parameter"
                v-model="value"
                @change.stop="updateValue($event)"
            >

            <label :for="parameter" class="form-label-checkbox">
                <div v-html="parameters.title.value"></div>
            </label>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget.vue';

    export default {
        extends: VisibleSelectorWidget,
        props: {
            parameter: String,
        },
        created() {
            this.render();
            this.registerParameterListeners(this.parameters, ['title']);
        },
        methods: {
            updateValue(event) {
                event.preventDefault();
                this.broadcast(event.target.checked);
            },
            broadcast(value) {
                const eventName = 'update' + this.parameter.replace(/^\w/, c => c.toUpperCase());
                window.events.emit(eventName, value);
            }
        }
    }
</script>
